import { render } from "./EmptyContent.vue?vue&type=template&id=57186604&ts=true"
import script from "./EmptyContent.vue?vue&type=script&lang=ts"
export * from "./EmptyContent.vue?vue&type=script&lang=ts"

import "./EmptyContent.vue?vue&type=style&index=0&id=57186604&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__